import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./HeaderMob.css";
import Logo from "../../Assets/Svg/Header/MilkyLogo.svg";
import HeaderOpen from "../../Assets/Svg/Header/HeaderOpen.svg";
import HeaderOpenBlue from "../../Assets/Svg/Header/HeaderOpenBlue.svg";
import HeaderClose from "../../Assets/Svg/Header/HeaderClose.svg";
import HeaderLang from "../../Assets/Svg/Header/IconLang.svg";
import HeaderLangBlue from "../../Assets/Svg/Header/IconLangBlue.svg";
import ArrowBlue from "../../Assets/Svg/Header/ArrowBlue.svg";
import { RoutesAr } from "../Hooks/RoutesDynamic/RoutesDynamic";
import ButtonContact from "../ButtonContact/ButtonContact";
import BlueLogo from "../../Assets/Svg/Header/MilkyLogoBlue.svg";
import { motion, AnimatePresence } from "framer-motion";
export default function ArHomeHeaderMob() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({
    about: false,
    brands: false,
    journey: false,
  });

  const toggleDropdown = (dropdown) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [dropdown]: !prevState[dropdown],
    }));
  };
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleLanguageChange = () => {
    const currentPath = location.pathname;
    const isArabic = currentPath.endsWith("/ar");
    const basePath = isArabic ? currentPath.slice(0, -3) : currentPath;
    const newPath = isArabic ? basePath : `${basePath}${basePath.endsWith("/") ? "ar" : "/ar"}`;
    navigate(newPath, { replace: true });
    setShowDropdown(false);
  };

  const OpenDropDown = () => {
    setShowDropdown(true);
    setTimeout(() => setIsAnimating(true), 10);
  };

  const CloseDropDown = () => {
    setIsAnimating(false);
    setTimeout(() => setShowDropdown(false), 300);
    setDropdownStates(false);
  };

  const handleNavigation = (path) => {
    navigate(path);
    CloseDropDown();
  };

  useEffect(() => {
    const handleScrollbar = () => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      if (showDropdown) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      } else {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };

    handleScrollbar();

    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [showDropdown]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerHeight * 0.47;
      if (window.scrollY > scrollThreshold) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="Header_Main_Mob">
        <div className="Header_Main_Container_Mob">
          <div className="Header_Container_Mob">
            <div className="OpenIcon_Mob">
              <div>
                <button className="OpenIcon_Mob_Button" onClick={OpenDropDown}>
                  <img src={isScrolled ? HeaderOpenBlue : HeaderOpen} alt="" />
                </button>
              </div>
              {/*  */}
              <div>
                <button className="OpenIcon_Mob_Button" onClick={handleLanguageChange}>
                  <div className={`TF16PxSC ${isScrolled ? "OIMBTOTHER" : "OIMBT"}`}>EN</div>
                  <img src={isScrolled ? HeaderLangBlue : HeaderLang} alt="" />
                </button>
              </div>
            </div>
            {/*  */}
            <div className="Logo">
              <Link to={RoutesAr.Home}>
                <img src={isScrolled ? BlueLogo : Logo} alt="Logo" className="Header_Logo_Mob" />
              </Link>
            </div>
          </div>
          <div className="BlurSection"></div>
          <div className="BlurSection2"></div>
          <div className="BlurSection3"></div>
        </div>
        {showDropdown && (
          <>
            <div className={`DrobDownContainer ${showDropdown ? "show" : ""}`}>
              <div className={`DropDownAnitmation2 ${isAnimating ? "DropDownAnitmation" : ""}`}>
                <div className="DropdownMenu">
                  <ul className="DropDown_ul ar">
                    <li onClick={() => toggleDropdown("about")}>
                      <div className="DropDown_ul_DD ar">
                        <div className="ul_DD_T ar">عن الشركة</div>
                        <div>
                          <motion.img
                            src={ArrowBlue}
                            alt=""
                            className="ul_DD_Img"
                            animate={{ rotate: dropdownStates.about ? 180 : 0 }}
                            transition={{ duration: 0.5 }}
                          />
                        </div>
                      </div>
                      <AnimatePresence>
                        {dropdownStates.about && (
                          <motion.div initial={{ maxHeight: 0 }} animate={{ maxHeight: "50vw" }} exit={{ maxHeight: 0 }} transition={{ duration: 0.3 }}>
                            <motion.ul
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              exit={{ opacity: 0 }}
                              transition={{ delay: 0.05, duration: 0.1 }}
                              className="SubMenu ar"
                            >
                              <li onClick={() => handleNavigation(RoutesAr.OurStory)}>قصتنا</li>
                              <li onClick={() => handleNavigation(RoutesAr.OurValues)}>القيم الخاصة بنا</li>
                              {/* <li onClick={() => handleNavigation(ROUTES.BoardMembers)}>أعضاء مجلس الإدارة</li> */}
                            </motion.ul>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </li>
                    <li onClick={() => toggleDropdown("brands")}>
                      <div className="DropDown_ul_DD ar">
                        <div className="ul_DD_T ar">علامتنا التجارية</div>
                        <div>
                          <motion.img
                            src={ArrowBlue}
                            alt=""
                            className="ul_DD_Img"
                            animate={{ rotate: dropdownStates.brands ? 180 : 0 }}
                            transition={{ duration: 0.5 }}
                          />
                        </div>
                      </div>
                      <AnimatePresence>
                        {dropdownStates.brands && (
                          <motion.div initial={{ maxHeight: 0 }} animate={{ maxHeight: "50vw" }} exit={{ maxHeight: 0 }} transition={{ duration: 0.3 }}>
                            <motion.ul
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              exit={{ opacity: 0 }}
                              transition={{ delay: 0.05, duration: 0.1 }}
                              className="SubMenu ar"
                            >
                              <li onClick={() => handleNavigation(RoutesAr.TheMilkman)}>ذا ميلك مان</li>
                              <li onClick={() => handleNavigation(RoutesAr.Reefy)}>ريفي</li>
                              <li onClick={() => handleNavigation(RoutesAr.FindOurProducts)}>منافذ البيع</li>
                              <li onClick={() => handleNavigation(RoutesAr.Recipes)}>الوصفات</li>
                            </motion.ul>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </li>
                    <li onClick={() => toggleDropdown("journey")}>
                      <div className="DropDown_ul_DD ar">
                        <div className="ul_DD_T ar">رحلة المنتجات</div>
                        <div>
                          <motion.img
                            src={ArrowBlue}
                            alt=""
                            className="ul_DD_Img"
                            animate={{ rotate: dropdownStates.journey ? 180 : 0 }}
                            transition={{ duration: 0.5 }}
                          />
                        </div>
                      </div>
                      <AnimatePresence>
                        {dropdownStates.journey && (
                          <motion.div initial={{ maxHeight: 0 }} animate={{ maxHeight: "50vw" }} exit={{ maxHeight: 0 }} transition={{ duration: 0.3 }}>
                            <motion.ul
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              exit={{ opacity: 0 }}
                              transition={{ delay: 0.05, duration: 0.1 }}
                              className="SubMenu ar"
                            >
                              <li onClick={() => handleNavigation(RoutesAr.MilkysFarm)}>مزرعة ميلكيز</li>
                              <li onClick={() => handleNavigation(RoutesAr.MeetTheCows)}>تعرف على الأبقار</li>
                              <li onClick={() => handleNavigation(RoutesAr.OurFactory)}>مصنعنا</li>
                              <li onClick={() => handleNavigation(RoutesAr.Logistics)}>الخدمات اللوجستية</li>
                            </motion.ul>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </li>
                    <div className="DropDown_ul_Last ar">
                      <li onClick={() => handleNavigation(RoutesAr.Csv)}>القيمة المشتركة</li>
                      <li onClick={() => handleNavigation(RoutesAr.Careers)}>المهن</li>
                    </div>
                  </ul>
                </div>
                <div className="SubMenu_ReachUs ar">
                  <Link to={RoutesAr.ReachUs}>
                    <ButtonContact Text="تواصل معنا" />
                  </Link>
                </div>
                <div className="BlurSectionMob"></div>
                <div className="CloseMobAction">
                  <button onClick={CloseDropDown}>
                    <img src={HeaderClose} alt="" />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
